import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-336c8fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center","gap":"12px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Programación según", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("No activa")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Ruta: ")
const _hoisted_8 = {
  key: 1,
  class: "logo centered"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/WEAS_LOGO.png",
  alt: "WEAS_LOGO"
}, null, -1))
const _hoisted_10 = { style: {"font-weight":"bold","color":"#303133"} }
const _hoisted_11 = { style: {"margin-bottom":"15px","display":"flex","align-items":"center"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"8px"} }, null, -1))
const _hoisted_13 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"8px"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_15 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_16 = {
  key: 0,
  style: {"text-align":"center","color":"#909399","padding":"20px"}
}
const _hoisted_17 = { style: {"font-weight":"bold","color":"#303133"} }
const _hoisted_18 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_19 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Nuevo")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Antiguo")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("IoT")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#c0c4cc","text-transform":"uppercase"} }, "Coordenadas", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Min", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Max", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Punto Y", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Punto X", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Alto (dy)", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Ancho (dx)", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#c0c4cc","text-transform":"uppercase"} }, "Umbral", -1))
const _hoisted_31 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_32 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_33 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_34 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Información de tipologías de agua ")
const _hoisted_36 = { class: "header-model" }
const _hoisted_37 = { style: {"margin-right":"5px"} }
const _hoisted_38 = { style: {"font-weight":"bold","color":"#606266"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Modelo", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }, "Modo", -1))
const _hoisted_41 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_42 = { style: {"font-size":"12px","color":"#909399","margin-bottom":"4px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No hay cámaras para configurar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_tmoa_info_dialog = _resolveComponent("tmoa-info-dialog")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_water_type_list = _resolveComponent("water-type-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_card, { style: {"height":"fit-content"} }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button_group, { style: {"margin-bottom":"25px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: _ctx.showForm === 'station' ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm = 'station'))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parameterType.station")), 1)
                ]),
                _: 1
              }, 8, ["type"]),
              _createVNode(_component_el_button, {
                type: _ctx.showForm === 'samplingPoint' ? 'primary' : 'default',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm = 'samplingPoint'))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parameterType.samplingpoint")), 1)
                ]),
                _: 1
              }, 8, ["type"])
            ]),
            _: 1
          }),
          (_ctx.showForm === 'station' && _ctx.station)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                model: _ctx.station,
                "label-position": "top",
                style: {"margin-left":"15px","margin-right":"15px"},
                ref: "form"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "night",
                            label: _ctx.$t('magnitude.luminosity')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.station.night,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.station.night) = $event)),
                                modelModifiers: { number: true },
                                type: "number",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "threshold",
                            label: _ctx.$t('label.threshold')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.station.threshold,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.station.threshold) = $event)),
                                modelModifiers: { number: true },
                                type: "number"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "wake_time",
                            label: _ctx.$t('label.wakeTime')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.station.wake_time,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.station.wake_time) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "sleep_time",
                            label: _ctx.$t('label.sleepTime')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.station.sleep_time,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.station.sleep_time) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "position",
                            label: _ctx.$t('label.position')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.station.position,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.station.position) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "fogging_active",
                            label: _ctx.$t('label.fogging')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio_group, {
                                modelValue: _ctx.station.fogging_active,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.station.fogging_active) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio, { label: true }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("label.yes")), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_radio, { label: false }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("label.no")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.station.massiveCapture)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 0,
                        shadow: "never",
                        class: "mt-3"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("label.massiveCapture")), 1),
                            _createVNode(_component_el_switch, {
                              onChange: _ctx.updatedPathPart1,
                              modelValue: _ctx.station.massiveCapture.active,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.station.massiveCapture.active) = $event))
                            }, null, 8, ["onChange", "modelValue"]),
                            _hoisted_2,
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.station.massiveCapture.type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.station.massiveCapture.type) = $event)),
                              placeholder: "Select",
                              style: {"width":"240px"},
                              disabled: !_ctx.station.massiveCapture.active,
                              onChange: _ctx.getInfoSamplingPoint
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "onChange"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, {
                            gutter: 12,
                            style: {"margin-top":"12px"}
                          }, {
                            default: _withCtx(() => [
                              (_ctx.station.massiveCapture.type === 'timetable')
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, { label: "Fecha de inicio" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: _ctx.station.massiveCapture.fromDateTime,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.station.massiveCapture.fromDateTime) = $event)),
                                            type: "datetime",
                                            format: "YYYY-MM-DD HH:mm",
                                            placeholder: "DD/MM/AAAA hh:mm",
                                            disabled: !_ctx.station.massiveCapture.active
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.station.massiveCapture.type === 'timetable')
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 1,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, { label: "Fecha de fin" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: _ctx.station.massiveCapture.toDateTime,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.station.massiveCapture.toDateTime) = $event)),
                                            type: "datetime",
                                            format: "YYYY-MM-DD HH:mm",
                                            placeholder: "DD/MM/AAAA hh:mm",
                                            disabled: !_ctx.station.massiveCapture.active
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.station.massiveCapture.type === 'tmoa')
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 2,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, {
                                        label: _ctx.$t('parameterType.tmoa')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.station.massiveCapture.typeTMOA,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.station.massiveCapture.typeTMOA) = $event)),
                                            multiple: "",
                                            style: {"width":"100%"}
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tmoasOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }, 8, ["label"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.station.massiveCapture.type === 'tmoa')
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 3,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_form_item, { label: "Estado" }, {
                                        default: _withCtx(() => [
                                          (_ctx.station.massiveCapture.tmoaActive)
                                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                                key: 0,
                                                type: "success"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.tmoaActiveName), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_tag, {
                                                key: 1,
                                                type: "info"
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_3
                                                ]),
                                                _: 1
                                              }))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "Configurar ruta" }, {
                                    default: _withCtx(() => [
                                      _hoisted_4,
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.path1,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.path1) = $event)),
                                        style: {"max-width":"300px","margin":"0 6px"},
                                        placeholder: "Código",
                                        disabled: !_ctx.station.massiveCapture.active,
                                        onInput: _ctx.updatedPath
                                      }, null, 8, ["modelValue", "disabled", "onInput"]),
                                      _hoisted_5,
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.station.massiveCapture.camera,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.station.massiveCapture.camera) = $event)),
                                        placeholder: "Cámara",
                                        disabled: !_ctx.station.massiveCapture.active,
                                        onChange: _ctx.updatedPath,
                                        style: {"width":"160px","margin-left":"6px"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationCameras?.stationsCamera || [], (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.camera?.code ?? item?.camera,
                                              label: item.camera?.code ?? item?.camera,
                                              value: item.camera?.code ?? item?.camera
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled", "onChange"]),
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", null, [
                                    _hoisted_7,
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.massiveCapture.path ??
                    "/" + _ctx.path1 + "/" + (_ctx.station.massiveCapture.camera ?? "") + "/"), 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_row, { style: {"margin-top":"16px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        style: {"display":"flex","gap":"12px","justify-content":"flex-end"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.doSaveStation,
                            disabled: !_ctx.canEdit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true),
          (!_ctx.station && _ctx.showForm === 'station')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.noStation")), 1),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          (_ctx.showForm === 'samplingPoint')
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 2,
                style: {"margin-left":"15px","margin-right":"15px"},
                ref: "samplingPointFormRef",
                model: _ctx.samplingPointForm
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: "app-form-item",
                    style: {"border":"1px solid #ebeef5","border-radius":"8px"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("label.issue_point")), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageStatus, (status, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_el_tag, {
                              effect: "dark",
                              type: "info",
                              size: "small",
                              style: {"margin-right":"10px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(status.camera), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(_component_el_row, {
                            gutter: 20,
                            style: {"margin-bottom":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _hoisted_12,
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        modelValue: status.stationOperation,
                                        "onUpdate:modelValue": ($event: any) => ((status.stationOperation) = $event),
                                        "active-text": "I",
                                        "inactive-text": "0",
                                        "inline-prompt": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 4 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("label.status")), 1),
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_el_button, {
                                          type: _ctx.showColor(status),
                                          circle: "",
                                          style: {"width":"14px","height":"14px","padding":"0","cursor":"default"},
                                          disabled: ""
                                        }, null, 8, ["type"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 14 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("label.lossThreshold")), 1),
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input_number, {
                                        modelValue: status.imageLossThreshold,
                                        "onUpdate:modelValue": ($event: any) => ((status.imageLossThreshold) = $event),
                                        min: 1,
                                        style: {"width":"100%"}
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (index < _ctx.imageStatus.length - 1)
                            ? (_openBlock(), _createBlock(_component_el_divider, {
                                key: 0,
                                style: {"margin":"20px 0"}
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      (_ctx.imageStatus.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("warning.notCameras")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: "app-form-item",
                    style: {"border":"1px solid #ebeef5","border-radius":"8px"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("label.labelling")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        style: {"margin-bottom":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("magnitude.luminosity")), 1),
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.day_night_threshold,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.samplingPointForm.day_night_threshold) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 16 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("label.labellingType")), 1),
                              _createVNode(_component_el_form_item, {
                                prop: "labellingScript",
                                style: {"margin-bottom":"0"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.samplingPointForm.labellingScript,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.samplingPointForm.labellingScript) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio_button, { label: "new" }, {
                                        default: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio_button, { label: "old" }, {
                                        default: _withCtx(() => [
                                          _hoisted_21
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio_button, { label: "iot" }, {
                                        default: _withCtx(() => [
                                          _hoisted_22
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, {
                        gutter: 15,
                        style: {"margin-bottom":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.minBlack,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.samplingPointForm.minBlack) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.maxWhite,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.samplingPointForm.maxWhite) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.yBright,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.samplingPointForm.yBright) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.xBright,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.samplingPointForm.xBright) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_28,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.dyBright,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.samplingPointForm.dyBright) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            md: 4,
                            xs: 12
                          }, {
                            default: _withCtx(() => [
                              _hoisted_29,
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointForm.dxBright,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.samplingPointForm.dxBright) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_divider, { "content-position": "left" }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, { gutter: 15 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("label.minAreaPercentage")), 1),
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointLabel.minArea,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.samplingPointLabel.minArea) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("label.minPixelPercentage")), 1),
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointLabel.minPixel,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.samplingPointLabel.minPixel) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("label.whiteThreshold")), 1),
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointLabel.whiteThreshold,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.samplingPointLabel.whiteThreshold) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("label.blackThreshold")), 1),
                              _createVNode(_component_el_input_number, {
                                modelValue: _ctx.samplingPointLabel.blackThreshold,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.samplingPointLabel.blackThreshold) = $event)),
                                style: {"width":"100%"},
                                "controls-position": "right"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: "app-form-item"
                  }, {
                    header: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("info_tmoa.title_info")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        underline: false,
                        onClick: _ctx.openTmoaDialog
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { style: {"margin-right":"4px"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_InfoFilled)
                            ]),
                            _: 1
                          }),
                          _hoisted_35
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_tmoa_info_dialog, {
                    modelValue: _ctx.isTmoaDialogVisible,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.isTmoaDialogVisible) = $event)),
                    tmoas: _ctx.tmoas,
                    "sampling-point-id": _ctx.samplingPoint?.id,
                    onRefresh: _ctx.loadTmoas,
                    canEdit: _ctx.canEdit
                  }, null, 8, ["modelValue", "tmoas", "sampling-point-id", "onRefresh", "canEdit"]),
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: "app-form-item"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t("label.modelCamera")), 1),
                          _createVNode(_component_el_tooltip, {
                            class: "box-item",
                            effect: "dark",
                            content: _ctx.$t('tooltip.activeEstimation'),
                            placement: "bottom-end"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_switch, {
                                "model-value": _ctx.samplingPoint?.throughModel,
                                class: "switch",
                                "active-text": "I",
                                "inactive-text": "0",
                                "inline-prompt": "",
                                onChange: _cache[28] || (_cache[28] = 
                        (val) => {
                          if (_ctx.samplingPoint) _ctx.samplingPoint.throughModel = val;
                        }
                      )
                              }, null, 8, ["model-value"])
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("label.average")) + " ", 1),
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.samplingPointForm.isMedian,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.samplingPointForm.isMedian) = $event)),
                            class: "switch"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.camerasConfiguration, (camera, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "camera-config-card"
                        }, [
                          _createVNode(_component_el_row, {
                            gutter: 20,
                            align: "middle",
                            style: {"margin-bottom":"20px","padding":"15px","border-bottom":"1px solid #eee"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_38, _toDisplayString(camera.camera?.name || "Cámara"), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_39,
                                  _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_switch, {
                                        modelValue: camera.modele,
                                        "onUpdate:modelValue": ($event: any) => ((camera.modele) = $event),
                                        "active-text": "I",
                                        "inactive-text": "0",
                                        "inline-prompt": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _hoisted_40,
                                  _createVNode(_component_el_select, {
                                    modelValue: camera.imageProcessingTime,
                                    "onUpdate:modelValue": ($event: any) => ((camera.imageProcessingTime) = $event),
                                    placeholder: "Seleccione modo",
                                    onChange: ($event: any) => (_ctx.ckeckCamera(camera)),
                                    style: {"width":"100%"},
                                    clearable: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: _ctx.$t('label.day'),
                                        value: "DAY"
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_el_option, {
                                        label: _ctx.$t('label.night'),
                                        value: "NIGHT"
                                      }, null, 8, ["label"]),
                                      _createVNode(_component_el_option, {
                                        label: _ctx.$t('label.all_day'),
                                        value: "ALL_DAY"
                                      }, null, 8, ["label"])
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("label.dirtThresholdDay")), 1),
                                  _createVNode(_component_el_input_number, {
                                    modelValue: camera.dirtThreshold,
                                    "onUpdate:modelValue": ($event: any) => ((camera.dirtThreshold) = $event),
                                    min: 0,
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { span: 5 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("label.dirtThresholdNight")), 1),
                                  _createVNode(_component_el_input_number, {
                                    modelValue: camera.dirtThresholdNight,
                                    "onUpdate:modelValue": ($event: any) => ((camera.dirtThresholdNight) = $event),
                                    min: 0,
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  (_ctx.camerasConfiguration.length <= 0)
                    ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_card, {
                    shadow: "never",
                    class: "app-form-item"
                  }, {
                    header: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("label.waterType")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_water_type_list, {
                        onUpdateWaterType: _ctx.getWaterType,
                        list: _ctx.waterType,
                        style: {"height":"250px !important"}
                      }, null, 8, ["onUpdateWaterType", "list"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { style: {"margin-top":"16px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 24,
                        style: {"display":"flex","gap":"12px","justify-content":"flex-end"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.doSaveSamplingPoint,
                            disabled: !_ctx.canEdit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}